import { render, staticRenderFns } from "./PickupGroupsModal.vue?vue&type=template&id=708422be&"
import script from "./PickupGroupsModal.vue?vue&type=script&lang=js&"
export * from "./PickupGroupsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports